import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Card,
  DataTable,
  EmptyState,
  ErrorState,
  LoadingState,
  PageHeader,
  currencyColumn,
  statusColumn,
  textColumn,
  type ColumnDef,
} from '@/components/ui'
import { customerApi } from '../lib/api'

interface Contract {
  id: string
  name: string
  status: string
  monthlyValue: number
}

const columns: ColumnDef<Contract, unknown>[] = [
  textColumn<Contract>('name', 'Vertrag'),
  statusColumn<Contract>('status'),
  currencyColumn<Contract>('monthlyValue', 'Monatlich'),
]

export function CustomerContractsPage() {
  const [rows, setRows] = useState<Contract[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const navigate = useNavigate()

  useEffect(() => {
    customerApi.get<{ data: Contract[] }>('/contracts')
      .then((res) => setRows(res.data?.data ?? []))
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <PageHeader title="Verträge" description="Aktuell laufende Service-Verträge." />
      {loading && <LoadingState />}
      {error && <ErrorState details={error} />}
      {!loading && !error && (
        <Card>
          <Card.Body>
            <DataTable<Contract>
              data={rows}
              columns={columns}
              getRowId={(r) => r.id}
              emptyState={
                <EmptyState
                  title="Keine Verträge hinterlegt"
                  description="Frage deinen Ansprechpartner oder sieh dir den Sicherheitsstatus an, um passende Services zu entdecken."
                  action={
                    <Button variant="primary" onClick={() => navigate('/sicherheitsstatus')}>
                      Sicherheitsstatus ansehen
                    </Button>
                  }
                />
              }
            />
          </Card.Body>
        </Card>
      )}
    </div>
  )
}
